<template>
  <div>
    <!-- 基準局 -->
    <v-card class="my-3">
      <v-card-title>
        <h5>{{ $tt('caster.logBaseTitle') }}</h5>
      </v-card-title>
      <v-card-text>
        <v-sheet class="body-1 mx-3" v-if="baseRows.length === 0">({{ $tt('caster.noStatsData') }})</v-sheet>
        <v-simple-table dense v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $tt('caster.startAt') }}</th>
                <th class="text-left">{{ $tt('caster.endAt') }}</th>
                <th class="text-right">{{ $tt('caster.bytesRate') }}</th>
                <th class="text-right">{{ $tt('caster.decodeErrors') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in baseRows" :key="row.key">
                <td>{{ row.startAt }}</td>
                <td>
                  <v-chip x-small color="primary" v-if="row.connected">{{ $tt('caster.inSession') }}</v-chip>
                  <span v-else>{{ row.endAt }}</span>
                </td>
                <td class="text-right">{{ row.rate }}</td>
                <td class="text-right">{{ row.decodeErrors }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </v-card-text>
    </v-card>

    <!-- 移動局 -->
    <v-card class="my-3">
      <v-card-title>
        <h5>{{ $tt('caster.logRoverTitle') }}</h5>
      </v-card-title>
      <v-card-text>
        <v-sheet class="body-1 mx-3" v-if="roverRows.length === 0">({{ $tt('caster.noTrackData') }})</v-sheet>
        <v-simple-table dense v-else>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">{{ $tt('caster.userId') }}</th>
                <th class="text-left">{{ $tt('caster.userAgentLabel') }}</th>
                <th class="text-left">{{ $tt('caster.startAt') }}</th>
                <th class="text-left">{{ $tt('caster.endAt') }}</th>
                <th class="text-right">GGA</th>
                <th class="text-right">{{ $tt('caster.ggaPoints') }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in roverRows" :key="row.key">
                <td>{{ row.clientId }}</td>
                <td class="caption">{{ row.userAgent }}</td>
                <td>{{ row.startAt }}</td>
                <td>
                  <v-chip x-small color="primary" v-if="row.connected">{{ $tt('caster.inSession') }}</v-chip>
                  <span v-else>{{ row.endAt }}</span>
                </td>
                <td class="text-right">{{ row.ggaSentences }}</td>
                <td class="text-right">{{ row.recordedPoints }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
        <div class="caption grey--text mt-2">{{ $tt('caster.logNote') }}</div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import moment from 'moment-timezone'

const FORMAT = 'MM/DD HH:mm:ss'

/**
 * 接続ログ: caster がメモリ内に保持する直近の基準局/移動局セッション (約24時間)
 */
export default {
  name: 'CasterConnectionLog',
  props: {
    stats: { type: Object, default: null }, // MountpointStats
    track: { type: Object, default: null }, // MountpointTrack
  },
  computed: {
    baseRows() {
      const rows = []
      const current = this.stats && this.stats.current
      if (current) {
        rows.push({
          key: 'current',
          connected: true,
          startAt: moment(current.collectedAt - current.uptimeSeconds * 1000).format(FORMAT),
          endAt: '',
          rate: `${Math.round(current.bytesInPerSecond)} B/s`,
          decodeErrors: current.decodeErrors,
        })
      }
      const lastEnded = this.stats && this.stats.lastEnded
      if (lastEnded && lastEnded.snapshot) {
        const snapshot = lastEnded.snapshot
        rows.push({
          key: 'lastEnded',
          connected: false,
          startAt: moment(lastEnded.endedAt - snapshot.uptimeSeconds * 1000).format(FORMAT),
          endAt: moment(lastEnded.endedAt).format(FORMAT),
          rate: `${Math.round(snapshot.bytesInPerSecond)} B/s`,
          decodeErrors: snapshot.decodeErrors,
        })
      }
      return rows
    },
    roverRows() {
      const rovers = (this.track && this.track.rovers) || []
      return rovers
        .slice()
        .sort((a, b) => b.startedAt - a.startedAt)
        .map((rover, index) => ({
          key: `rover-${index}`,
          clientId: rover.clientId || rover.roverId,
          userAgent: rover.userAgent || '--',
          connected: !rover.endedAt,
          startAt: moment(rover.startedAt).format(FORMAT),
          endAt: rover.endedAt ? moment(rover.endedAt).format(FORMAT) : '',
          ggaSentences: rover.stats ? rover.stats.ggaSentences : 0,
          recordedPoints: rover.stats ? rover.stats.recordedPoints : 0,
        }))
    },
  },
}
</script>
